// extracted by mini-css-extract-plugin
export default {"link":"YD-z","disabled":"ZD-z"};